import React, { useEffect, useState } from 'react';
import '../css/Header.css';
import '../css/Body.css';

/* 폰트어썸 import */
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

const info = require('../config/info');
const session = require('../utils/session');

function NotFound() {
    let navigate = useNavigate();
    const dispatch = useDispatch();

    const isLogin = session.getIsLogin();

    useEffect(() => {
        if (!isLogin) {
            navigate('/Login');
            return;
        }
    }, [isLogin, navigate]);

    const onLogoutHandler = (event) => {
        event.preventDefault();
        session.clearSession();
        window.location.replace('/');
    };

    return (
        <div className="container">
            <div className="header-wrap">
                <h1>notfound</h1>
                <div className="input-seach">
                    <input type="text" id="Seach" name="검색" placeholder="검색어를 입력해주세요."/>
                    <FontAwesomeIcon className="seach-icon" icon={faMagnifyingGlass} />
                </div>
                <div className="info-wrap">
                    <div className="info-id">
                        <span>{info.name}</span>
                        <button className="logout-btn" onClick={onLogoutHandler}>로그아웃</button>
                    </div>
                    <div className="info-email">
                        {info.email}
                    </div>
                </div>
            </div>

            <div>
                
            </div>
        </div>
    )
}

export default NotFound;
